function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

var TableRow = function TableRow(_ref) {
  var onClick = _ref.onClick,
      style = _ref.style,
      className = _ref.className,
      children = _ref.children;
  var is_onclick = typeof onClick === "function"; // I put the click on tr b/c I was getting invalid dom nesting

  var td_props = is_onclick ? {
    onClick: onClick,
    role: "button",
    tabIndex: 0
  } : {};

  if (style) {
    td_props = _objectSpread(_objectSpread({}, td_props), {
      style: style
    });
  }

  return /*#__PURE__*/React.createElement("tr", _extends({
    className: classNames("et--flex-table--row", className, {
      "is-button": is_onclick
    })
  }, td_props), children);
};

TableRow.propTypes = {
  style: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default TableRow;